import React from 'react';

import './style.scss';
import Icons from '../../Icons';

const CSocials = ({socials, onClick}) => {
    return (
        <div className="c-socials">
            {
                socials.map((social, index) => (
                    !!social.link &&
                    <a
                        key={index}
                        href={social.link}
                        className="c-socials-link"
                        target="_blank"
                        onClick={(e) => onClick(e, social)}
                    >
                        <Icons name={social.type} />
                    </a>
                ))
            }
            
        </div>
    )
};

export default CSocials;
